import router from "./router"
import urls from "./urls"
import { DEFAULT_VIEW } from "./urls"

export default (name = DEFAULT_VIEW, params = {}) =>
  router.push(urls[name].navigate(params))
